import usePermissionCheck from "presentation/hooks/use-check-permissions";
import React from "react";
import FunctionHeader from "../../components/Header/FunctionHeader";
import Spinner from "presentation/components/Shared/Spinner";
import { translateText } from "infra/translation/translate";
import WebsitePanel from "presentation/components/Website/WebsitePanel";

const WebsitePage = ({ children }: { children?: React.ReactNode }) => {
  const { isLoading } = usePermissionCheck({ requiredFunction: "website" });

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <div>
      <FunctionHeader title={translateText("Website Config", "pt")} />
      <WebsitePanel />
    </div>
  );
};

export default WebsitePage;
